<template>
  <div class="table grid-shadow">
    <table
        :style="{ paddingTop: gridConfig.props.filterable ? gridConfig.props.headerRowHeight + 50 + 'px' : gridConfig.props.headerRowHeight + 5 + 'px'}">
      <div class="table-header no-select">
        <thead>
        <!--        column names            -->
        <tr :style="{ height: gridConfig.props.headerRowHeight + 'px' }">
          <!--        selectable column            -->
          <th v-if="gridConfig.props.selectableColumn.show"
              :style="{ width: gridConfig.props.selectableColumn.width ? gridConfig.props.selectableColumn.width + 'px' : defaultSelectableColumnWidth + 'px'}">
          </th>

          <th :key="column.id"
              :style="{ width: column.width + 'px' }"
              @click="setSortSelector(column)"
              v-for="column in gridConfig.columns">
            {{ column.name }}
            <i :class="getIcon(column.selector)" class="sort-icon"></i>
          </th>
        </tr>
        <!--        filter row        -->
        <tr v-if="gridConfig.props.filterable">
          <!--        selectable column            -->
          <th v-if="gridConfig.props.selectableColumn.show"
              :style="{ width: gridConfig.props.selectableColumn.width ? gridConfig.props.selectableColumn.width + 'px' : defaultSelectableColumnWidth + 'px'}">
          </th>

          <th :key="column.id"
              :style="{ width: column.width + 'px' }"
              v-for="column in gridConfig.columns">
            <div class="filter-input">
              <InputText :id="column.id + ''"
                         v-if="!column.filterComponent && column.type !== 'boolean'"
                         :name="column.selector"
                         @value-change="setFilter">
              </InputText>

              <component v-if="column.filterComponent"
                         :is="column.filterComponent"
                         :id="column.id + ''"
                         :name="column.selector"
                         @selection-change="setFilter"/>
            </div>
          </th>
        </tr>
        </thead>
      </div>
      <div :style="{ height: gridConfig.props.tableHeight + 'px' }" class="table-body">
        <tbody v-if="!isLoading">

        <p class="empty-list" v-if="isEmpty">Няма намерени записи</p>
        <!--        rows            -->
        <tr :key="row.id"
            :style="{ height: gridConfig.props.rowHeight + 'px' }"
            class="body-row"
            v-for="row in getPageRows()">

          <!--        selectable column            -->
          <td v-if="gridConfig.props.selectableColumn.show"
              :style="{ width: gridConfig.props.selectableColumn.width ? gridConfig.props.selectableColumn.width + 'px' : defaultSelectableColumnWidth + 'px'}">
            <a @click="iconClicked(row)" v-show="!isEmpty">
              <i :class="gridConfig.props.selectableColumn.icon" class="selectable-icon"></i>
            </a>
          </td>

          <td :key="column.id"
              :style="{ width: column.width + 'px' }"
              v-for="column in gridConfig.columns">
            {{ column.type === 'date' ? formatDateColumn(row[column.selector]) :
              column.type === 'boolean' ? getBooleanData(row[column.selector]) : row[column.selector] }}
          </td>

        </tr>
        </tbody>

        <!-- while loading -->
        <div class="loading-image"
             v-if="isLoading">
          <i class="fa-7x fas fa-circle-notch fa-spin"></i>
        </div>
        <tbody v-if="isLoading">
        <tr :style="{ height: gridConfig.props.rowHeight + 'px' }">

          <td v-if="gridConfig.props.selectableColumn.show"
              :style="{ width: gridConfig.props.selectableColumn.width ? gridConfig.props.selectableColumn.width + 'px' : defaultSelectableColumnWidth + 'px'}">
          </td>

          <td :key="column.id"
              :style="{ width: column.width + 'px' }"
              v-for="column in gridConfig.columns">
          </td>
        </tr>
        </tbody>
      </div>

      <div class="table-footer no-select">
        <tfoot>
        <tr :style="{ height: gridConfig.props.headerRowHeight + 'px' }">
          <!--        selectable column            -->
          <td v-if="gridConfig.props.selectableColumn.show"
              :style="{ width: gridConfig.props.selectableColumn.width ? gridConfig.props.selectableColumn.width + 'px' : defaultSelectableColumnWidth + 'px'}">
          </td>

          <td :key="column.id"
              :style="{ width: column.width + 'px' }"
              @click="setSortSelector(column)"
              v-for="column in gridConfig.columns">
          </td>
        </tr>
        <div class="page-counter">
          <LiteButton @click.native="goToPage(1)"
                      class="page-counter-button"
                      :hoverColor="'blue'"
                      :icon="'fas fa-angle-double-left'"/>
          <LiteButton @click.native="goToPage(currentPage - 1)"
                      class="page-counter-button"
                      :hoverColor="'blue'"
                      :icon="'fas fa-angle-left'"/>
          <p class="page-counter-text">{{ currentPage }} от {{ getLastPage() }}</p>
          <LiteButton @click.native="goToPage(currentPage + 1)"
                      class="page-counter-button"
                      :hoverColor="'blue'"
                      :icon="'fas fa-angle-right'"/>
          <LiteButton @click.native="goToLastPage(1)"
                      class="page-counter-button"
                      :hoverColor="'blue'"
                      :icon="'fas fa-angle-double-right'"/>
        </div>
        </tfoot>
      </div>
    </table>
  </div>
</template>

<script>
import InputText from "@/shared/components/form/InputText";
import utilService from "@/services/util.service";
import {cloneDeep} from 'lodash';
import dateService from "@/services/date.service";
import LiteButton from "@/shared/components/button/LiteButton";

export default {
  name: "Grid",
  components: {LiteButton, InputText},
  props: {
    config: Object,
    gridData: Array,
    loading: Boolean
  },
  created() {
  },
  mounted() {
    // sort columns
    this.gridConfig.columns = this.gridConfig.columns.sort((a, b) => a.sequenceNumber - b.sequenceNumber);

    // set row data
    if (this.gridData) {
      this.initialRowsData = cloneDeep(this.gridData);
      this.rowsData = cloneDeep(this.gridData);
    } else {
      this.isEmpty = true;
    }
  },
  data() {
    return {
      gridConfig: cloneDeep(this.config),
      initialRowsData: [],
      rowsData: [],
      sortSelector: {
        shouldSort: false,
        column: {},
        asc: true
      },
      filters: [],
      isEmpty: false,
      isLoading: this.loading,
      defaultSelectableColumnWidth: 30,
      currentPage: 1,
      pageSize: 20
    };
  },
  methods: {
    formatDateColumn(date) {
      return date ? dateService.formatDate(date) : '';
    },

    getBooleanData(flag) {
      if (flag === undefined) {
        return '';
      }
      return flag ? 'Да' : 'Не';
    },

    iconClicked(row) {
      this.$emit('row-clicked', row);
    },

    setSortSelector(column) {
      // if no sort applied
      if (!this.sortSelector.shouldSort) {
        this.sortSelector.shouldSort = true;
        this.sortSelector.column = column;
        this.sortSelector.asc = true;
      } else {
        // if there is sort applied and the sort is same as new one
        if (this.sortSelector.column === column) {
          // if is asc - change to desc
          if (this.sortSelector.asc) {
            this.sortSelector.asc = false;
          } else {
            // if is desc - disable sort
            this.sortSelector.shouldSort = false;
          }
        } else {
          // if there is sort but for different column
          this.sortSelector.column = column;
          this.sortSelector.shouldSort = true;
          this.sortSelector.asc = true;
        }
      }
    },

    sort() {
      // if should sort and column type is defined
      if (this.sortSelector.shouldSort && this.sortSelector.column.type) {
        if (this.sortSelector.column.type === 'string') {
          this.rowsData = utilService.sortArrayByStringSelector(this.rowsData, this.sortSelector.column.selector, this.sortSelector.asc);
        } else {
          if (this.sortSelector.column.type === 'number') {
            this.rowsData = utilService.sortArrayByNumberSelector(this.rowsData, this.sortSelector.column.selector, this.sortSelector.asc);
          } else {
            if (this.sortSelector.column.type === 'date') {
              this.rowsData = utilService.sortArrayByDateSelector(this.rowsData, this.sortSelector.column.selector, this.sortSelector.asc);
            }
          }
        }
      } else {
        // if sort removed but there are filters
        if (!this.filters.length > 0) {
          this.rowsData = cloneDeep(this.initialRowsData);
        }
      }
    },

    setFilter(event) {
      let filter = this.filters.find((filter) => filter.id === event.id);
      if (filter) {
        if (event.currentValue) {
          // if filter is present - change it's value
          this.filters = this.filters.filter((temp) => temp.id !== filter.id);
          this.filters.push(event);

        } else {
          // if new value is empty - remove the filter
          this.filters = this.filters.filter((temp) => temp.id !== filter.id);
        }
      } else {
        // if this filter still hasn't been applied
        this.filters.push(event);
      }
    },
    applyFilter(filter, array) {
      if (filter.isDropdown && filter.currentValue) {
        return array.filter((row) => {
          if (row[filter.name]) {
            return row[filter.name].toString().toLowerCase() === filter.currentValue.toLowerCase();
          }
          return false;
        });
      }
      if (filter.currentValue) {
        return array.filter((row) => {
          if (row[filter.name]) {
            return row[filter.name].toString().toLowerCase().includes(filter.currentValue.toLowerCase());
          }
          return false;
        });
      }
      return array;
    },
    filter() {
      let tempData = cloneDeep(this.initialRowsData);
      this.filters.forEach((filter) => tempData = this.applyFilter(filter, tempData));
      this.rowsData = tempData;

      // remove sort when filtering
      this.sortSelector.shouldSort = false;
    },

    getIcon(column) {
      // icon for sort
      if (!this.sortSelector.shouldSort || column !== this.sortSelector.column.selector) {
        return '';
      }

      return this.sortSelector.asc ? 'fa fa-long-arrow-alt-down' : 'fa fa-long-arrow-alt-up';
    },

    getPageRows() {
      return this.rowsData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },

    getLastPage() {
      let lastPage = Math.floor(this.rowsData.length / this.pageSize);
      if (this.rowsData.length % this.pageSize !== 0) {
        lastPage += 1;
      }
      return lastPage;
    },
    goToPage(page) {
      if (page !== 0 && page !== this.getLastPage() + 1) {
        this.currentPage = page;
      }
    },
    goToLastPage() {
      this.currentPage = this.getLastPage();
    }
  },
  watch: {
    sortSelector: {
      handler() {
        this.sort();
      },
      deep: true
    },
    filters: {
      handler() {
        this.currentPage = 1;
        this.filter();
        this.isEmpty = false;
      },
      deep: true
    },
    rowsData: {
      handler(newVal) {
        // if there is now data
        if (newVal.length === 0) {
          this.isEmpty = true;
          this.rowsData.push({});
        }
      },
      deep: true
    },
    gridData: {
      handler(newVal) {
        this.isEmpty = false;
        this.initialRowsData = cloneDeep(newVal);
        this.rowsData = cloneDeep(newVal);
      },
      deep: true
    },
    config: {
      handler(newVal) {
        if (newVal) {
          cloneDeep(this.gridConfig = newVal);
        }
      },
      deep: true
    },
    loading(newVal) {
      this.isLoading = newVal;
    }
  }
}
</script>

<style scoped>
.table {
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  width: fit-content;
  position: relative;
  overflow-x: auto;
}

table {
  border-spacing: 0;
  padding-bottom: 50px;
  width: max-content;
}

td, th {
  padding: 0 20px;
  font-size: 20px;
  box-sizing: border-box;
}

th {
  text-align: center;
}

th:hover {
  cursor: pointer;
}

td {
  border-bottom: 1px solid var(--lighter-grey);
  text-align: left;
  padding: 0 30px;
}

.table .table-header {
  box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.1);
}

.table-header {
  position: absolute;
  width: max-content;
  padding-right: 15px;
  top: 0;
  left: 0;
}

.table .table-footer {
  box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1);
}

.table-footer {
  position: absolute;
  background-color: #ffffff;
  height: 50px;
  width: max-content;
  padding-right: 15px;
  bottom: 0;
  left: 0;
}

.table-body {
  overflow-y: scroll;
}

.body-row:hover {
  background-color: var(--very-light-grey);
}

.filter-input {
  height: 45px;
}

.sort-icon {
  margin-left: 5px;
}

.empty-list {
  position: absolute;
  margin: 15px auto;
  width: 100%;
  font-size: 28px;
  color: var(--grey);
  text-align: center;
}

.selectable-icon {
  color: var(--grey);
  cursor: pointer;
  font-size: 1.2em;
}

.selectable-icon:hover {
  color: var(--primary-blue);
}

.page-counter {
  position: absolute;
  height: 50px;
  box-sizing: border-box;
  bottom: 0;
  left: 20px;
  padding-top: 12px;
}

.page-counter-text {
  float: left;
  display: inline-block;
  width: fit-content;
  font-size: 22px;
  color: var(--dark-grey);
  margin-right: 10px;
}

.page-counter-button {
  float: left;
  display: inline-block;
  width: fit-content;
  font-size: 25px;
  color: var(--light-primary-blue);
}

.loading-image {
  margin-top: 150px;
  color: var(--slight-light-blue);
  position: absolute;
  width: 100%;
}

</style>
